import { withI18n } from 'react-i18next';
import InvoicesDesktop from './Desktop/';
import InvoicesMobile from './Mobile/';

export const pureComponentDesktop = InvoicesDesktop;
export const pureComponentMobile = InvoicesMobile;
export const Desktop = withI18n()(InvoicesDesktop);
export const Mobile = withI18n()(InvoicesMobile);
